/**
 * This file was auto-generated by scripts/generate-pagination-paths.ts
 * Do not make direct changes to the file.
 */

export const GET_LAST_ID_PATHS = [
  "/collections/{id}/prayers",
  "/communities/{community_id}/broadcasts",
  "/community/intentions/{id}/notes-of-support",
  "/intentions",
  "/journals",
  "/me/admin/communities/{community_id}/activity-feed",
  "/me/communities/{selector}/activity-feed",
  "/moodchecks",
  "/notifications",
  "/trusted/collections/{id}/prayers",
] as const;

export const GET_LAST_ID_PATHS_SET = new Set<string>(GET_LAST_ID_PATHS);
